// src/utils/analytics.js

const trackEvent = function(eventName, eventParams) {
    // Default empty object if eventParams is not provided
    eventParams = eventParams || {};
    
    // Ensure dataLayer exists
    window.dataLayer = window.dataLayer || [];
    
    // Create event object
    var eventObject = {
      event: eventName
    };
    
    // Add all parameters to the event object
    for (var key in eventParams) {
      if (eventParams.hasOwnProperty(key)) {
        eventObject[key] = eventParams[key];
      }
    }
    
    // Push the event to dataLayer
    window.dataLayer.push(eventObject);
    
    // Optional: Log events during development
    if (process.env.NODE_ENV === 'development') {
      console.log('Event tracked:', eventName, eventParams);
    }
  };
  
  export { trackEvent };